import { takeLatest, put, call, all, fork } from 'redux-saga/effects';
import SectionTypes from './section.types';
import { createSection, updateSection, getSectionsByOrganisation } from './section.services';
import {
	createSectionSuccess,
	createSectionFailure,
	updateSectionSuccess,
	updateSectionFailure,
	getSectionsByOrganisationSuccess,
	getSectionsByOrganisationFailure,
} from './section.action';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

// Create Section Saga
export function* createSectionSaga(payload: any) {
	try {
		const encryptedData = encryptData(payload.payload, SectionTypes.CREATE_SECTION_KEY);
		// @ts-ignore
		const responseData = yield call(createSection as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(createSectionSuccess(responseData.data));
			} else {
				yield put(createSectionFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(createSectionFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

// Update Section Saga
export function* updateSectionSaga(payload: any) {
	try {
		const encryptedData = encryptData(payload.payload, SectionTypes.UPDATE_SECTION_KEY);
		// @ts-ignore
		const responseData = yield call(updateSection as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(updateSectionSuccess(responseData.data));
			} else {
				yield put(updateSectionFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(updateSectionFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

// Get Sections By Organisation Saga
export function* getSectionsByOrganisationSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			SectionTypes.GET_SECTIONS_BY_ORGANISATION_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getSectionsByOrganisation as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getSectionsByOrganisationSuccess(responseData.data));
			} else {
				yield put(getSectionsByOrganisationFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getSectionsByOrganisationFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

// Watcher Sagas
export function* onCreateSectionStart(): Generator<any, void, any> {
	yield takeLatest(SectionTypes.CREATE_SECTION_START as any, createSectionSaga);
}

export function* onUpdateSectionStart(): Generator<any, void, any> {
	yield takeLatest(SectionTypes.UPDATE_SECTION_START as any, updateSectionSaga);
}

export function* onGetSectionsByOrganisationStart(): Generator<any, void, any> {
	yield takeLatest(
		SectionTypes.GET_SECTIONS_BY_ORGANISATION_START as any,
		getSectionsByOrganisationSaga,
	);
}

// Main Saga
export function* sectionSagaDetails(): Generator<any, void, any> {
	yield all([
		fork(onCreateSectionStart),
		fork(onUpdateSectionStart),
		fork(onGetSectionsByOrganisationStart),
	]);
}
